export enum DeepLinkType {
  ProviderId = 'provider_id',
  TapToPaySetup = 'ttp_setup',
  ChatId = 'chat_id',
  AppointmentList = 'appointment_list',
  ProviderStats = 'provider_stats',
  ProviderGrowthTabSummary = 'provider_growth_tab_summary',
  SearchPage = 'search',
  ProviderSettingsPlanSelection = 'provider_settings_plan_selection',
  ProviderSettingsOnlineBooking = 'provider_settings_online_booking',
  ClientIntakeForm = 'client_intake_form',
  ProviderViewIntakeForm = 'provider_view_intake_form',
}
